import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  max-width: 730px;
  margin: 0 auto;
  text-align: center;

  .review {
    &__text {
      font-size: 3.2rem;
      line-height: 3.6rem;
      margin-bottom: 50px;

      ${breakpoints.down('sm')} {
        font-size: 2.6rem;
        line-height: 3rem;
      }
    }
  }
`;

export default Container;
